import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteSavedSearch, endDeleteSearch } from '../store/actions/saved_searches';
import DeleteSavedSearch from 'components/modals/delete_saved_search_modal';

export class CompsDeleteSavedSearch extends React.Component {
  static propTypes = {
    deleteSavedSearch: PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const { deleteSavedSearch, onCancel, onDelete } = this.props;

    return (
      <DeleteSavedSearch
        search={deleteSavedSearch}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    );
  }
}

const mapStateToProps = state => ({
  deleteSavedSearch: state.savedSearches.deleteSavedSearch
});

const mapDispatchToProps = {
  onDelete: deleteSavedSearch,
  onCancel: endDeleteSearch
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsDeleteSavedSearch);